// extracted by mini-css-extract-plugin
module.exports = {"search-dialog-result-item-active":"search_search-dialog-result-item-active__1ATP8","search-dialog-result-item-right-icon":"search_search-dialog-result-item-right-icon__11eYq"};